import $ from "cash-dom";
import {centers, daysOfWeek} from "./data";

export const mapComponent = root => {
    const $r = $(root);
    const $selectCenter = $r.find('.select-center');

    const table = $r.find('#map-centers-table').get(0);
    const selectCenter = $selectCenter.get(0);
    const emailField = $r.find('.email-field').get(0);
    const phoneLink = $r.find('.phone-link').get(0);
    const addressField = $r.find('.address-field').get(0);
    const addressLink = $r.find('.address-link').get(0);
    const openingHoursField = $r.find('.opening-hours-field').get(0);
    const imageImg = $r.find('.image-img').get(0);
    const additionalInfoField = $r.find('.additional-info-field').get(0);

    let oldId = null;

    selectCenter.innerHTML = '<option value="0" selected>Vyberte jednu z možností...</option>' + centers
        .sort((l, r) => l.name.localeCompare(r.name))
        .flatMap(
            ({id, name}) => `<option value="${id}">${name}</option>`
        )
        .join('\n');
    selectCenter.value = '0';

    const openingHours = (center) => {
        const openingHours = center?.opening_hours || '';
        return Array.isArray(openingHours)
            ? openingHours.map(
                (text, n) => `<div class="govuk-grid-row">
<div class="govuk-grid-column-one-half govuk-grid-column-one-third-from-desktop">${daysOfWeek[n]}</div>
<div class="govuk-grid-column-one-half govuk-grid-column-two-thirds-from-desktop">${text}</div>
</div>`
            ).join('')
            : openingHours;
    };

    const onChange = id => {
        
        oldId = id;

        const center = centers.find(center => center.id === id);

        if (center) {
            emailField.innerText = center?.email || '';
            phoneLink.setAttribute('href', center?.phone.href || '');
            phoneLink.innerText = center?.phone.text || '';
            addressField.innerText = center?.address || '';
            addressLink.style.display = center ? 'initial' : 'none';
            addressLink.setAttribute('href', center?.navigate || '');
            openingHoursField.innerHTML = openingHours(center);

            const image = center?.image || null;
            imageImg.src = image;
            imageImg.style.display = image ? 'inline' : 'none';
            additionalInfoField.innerHTML = center?.additionalInfo || '';

            table.style.display = 'block';
        } else
            table.style.display = 'none';
    };

    selectCenter.onchange = e => onChange(parseInt(e.target.value));
    imageImg.onclick = () => $(imageImg).toggleClass('active');
    onChange(selectCenter.value);
};

